import axios from "axios";

// Replay a request that 401'd, once, with the current (renewed) token. Marked
// so a second 401 on the replay signs out instead of looping (api/session).
export function replayWithCurrentToken(config) {
  const headers = {
    ...(typeof config?.headers?.toJSON === "function" ? config.headers.toJSON() : config?.headers || {}),
  };
  headers.Authorization = `Bearer ${localStorage.getItem("authToken")}`;
  return axios.request({ ...config, headers, _retriedAfterRefresh: true });
}

export default replayWithCurrentToken;
